import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { connect } from 'react-redux';
import { prepareUrl, prepareNewWindowUrl } from '../../../utilities/StringHelpers/StringHelpers';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import { isMobile } from 'react-device-detect';
import Config from '../../../Config';
import { parentalControlReport } from './ParentalControlReports';
import { gtag4 } from '../../../utilities/analytics/tracking';
import { saveToHistory, setParentalCodeStep } from '../../Block/TvActivationCodeRecoveryBlock/TvActivationCodeRecoveryBlockSlice';

const ResetCodeCompleted = (props) => {

  useEffect(() => {
    if (props.resetParentalCodeStatus.resetParentalCodeReady && props.resetParentalCodeStatus.resetParentalCodeIsSuccess) {
      props.saveToHistory('reset-success');

    }
    else if (props.resetParentalCodeStatus.resetParentalCodeReady && !props.resetParentalCodeStatus.resetParentalCodeIsSuccess) {
      props.saveToHistory('reset-fail');
    }
  }, [props.resetParentalCodeStatus.resetParentalCodeIsSuccess]);

  useEffect(() => {

    if (props.resetParentalCodeStatus.resetParentalCodeReady) {
      if (props.resetParentalCodeStatus.resetParentalCodeIsSuccess) {
        parentalControlReport('New Parental Code Page', 'Completed', 'Success', props.account?.username, props.userData?.firstName
          + ' ' + props.userData?.lastName, props.userData?.IDNumber, '', '');
        gtag4({ event: 'ParentalControlCode_Step3_NewCodeSaved', step: '3', action: 'NewCodeSaved' }) //Google analytic

      }
      else if (props.resetParentalCodeStatus.resetParentalCodeIsSuccess != null && !props.resetParentalCodeStatus.resetParentalCodeIsSuccess) {
        let numOfUsers = 'מספר היוזרים' + props.numOfAccounts;

        parentalControlReport('New Parental Code Page', 'Error', 'General Error', props.account?.username, props.userData?.firstName
          + ' ' + props.userData?.lastName, props.userData?.IDNumber, '', '');
        gtag4({ event: 'ParentalControlCode_Step4_ErrorMessagePage', step: '4', action: 'ErrorMessagePage', content: numOfUsers }) //Google analytic

      }

    }

  }, [props.resetParentalCodeStatus.resetParentalCodeReady])

  if (props.resetParentalCodeStatus.resetParentalCodeReady && props.resetParentalCodeStatus.resetParentalCodeIsSuccess) {
    return (
      <div className='parental-code-success'>
        <Image src={require('./images/success.svg')} />
        <div className='text'>הקוד החדש נשמר בהצלחה!</div>
        <BtnSubmit
          onclick={() => {
            prepareUrl('/selfcare/lobby', props.context)
          }}
          text='סיום'
        />
      </div>
    );
  } else if (props.resetParentalCodeStatus.resetParentalCodeReady && !props.resetParentalCodeStatus.resetParentalCodeIsSuccess) {
    const errorMsg1 = "אופס , כרגע לא ניתן לבצע את הפעולה אנא נסו שוב מאוחר יותר";
    const errorMsg2 = "נציגינו עומדים לשירותך";
    const errorMsg3 = `חייגו ${window.Config.technicalSupportPhone} לנציג שירות`;


    return (
      <div className='parental-code-fail'>
        <Image src={require('./images/error.svg')} />
        <div className='txt-block-1'>{errorMsg1}</div>
        <div className='txt-block-2'>{errorMsg2}</div>

        {!isMobile ? (
          <>
            <div className='btn-wa' onClick={() => {
              prepareNewWindowUrl(`https://${window.location.hostname}/clm/16/20/`, props.context)
            }}>
              <span className='img-wa'>
                <Image style={{ marginLeft: "5px" }} src={require('./images/wa.svg')} />
              </span>
              <span className='txt-wa'>לנציג שירות ב-WhatsApp</span>
            </div>
            <div className='txt-block-3'>{errorMsg3}</div>
          </>
        ) :
          <>
            <div className='txt-block-3-mobile' onClick={() => prepareNewWindowUrl(`tel:${Config.numberCallCenterAbroad.replace('-', '')}`, props.context)}>{errorMsg3}</div>

            <div className='btn-wa' onClick={() => {
              prepareNewWindowUrl(`https://${window.location.hostname}/clm/16/20/`, props.context)
            }}>
              <span className='img-wa'>
                <Image style={{ marginLeft: "5px" }} src={require('./images/wa.svg')} />
              </span>
              <span className='txt-wa'>לנציג שירות ב-WhatsApp</span>
            </div>


          </>
        }
        <BtnWhite
          style={{ height: '50px' }}
          text={'חזרה לאיזור האישי'}
          onclick={() => {
            prepareUrl('/selfcare/lobby', props.context)
          }
          }
        />
      </div>
    );
  }
  else {
    return null;
  }

};

const mapStateToProps = (state) => {
  return {
    resetParentalCodeStatus: state.TvActivationCodeRecovery,
  };
};

const mapDispatchToProps = {
  saveToHistory,
  setParentalCodeStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetCodeCompleted);
